// extracted by mini-css-extract-plugin
export default {"ServiceSampleStyl":"SampleModal_ServiceSampleStyl__8yQqb","sampleItemStyl":"SampleModal_sampleItemStyl__xWYXc","colspan2":"SampleModal_colspan2__cLEqR"};